// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import {
    chain,
    SetUnitOfMeasureAndQtyOrdered as baseSetUnitOfMeasureAndQtyOrdered,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { createFromProduct, ProductInfo } from "@store/Modules/client-framework/src/Common/ProductInfo";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetUnitOfMeasureAndQtyOrdered = createChainHandler("SetUnitOfMeasureAndQtyOrdered", chain, props => {
    // Only the "createFromProduct" function import has changed.
    if (!props.product) {
        return;
    }

    const productInfos = [createFromProduct(props.product)];
    if (props.variantChildren) {
        productInfos.push(...props.variantChildren.map(createFromProduct));
    }

    props.productInfosById = productInfos.reduce((map, productInfo) => {
        map[productInfo.productId] = productInfo;
        return map;
    }, {} as SafeDictionary<ProductInfo>);
});

replaceInChain(chain, baseSetUnitOfMeasureAndQtyOrdered, SetUnitOfMeasureAndQtyOrdered);
